export const SESSION_ID_STORAGE_KEY = 'qb_session_id';

let cached: string | null = null;

function generate(): string {
  return `s-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2, 12)}`;
}

export function getSessionId(): string {
  if (cached) return cached;

  let fromStorage: string | null = null;
  try {
    fromStorage = sessionStorage.getItem(SESSION_ID_STORAGE_KEY);
  } catch {
    fromStorage = null;
  }

  if (fromStorage) {
    cached = fromStorage;
    return cached;
  }

  const fresh = generate();
  try {
    sessionStorage.setItem(SESSION_ID_STORAGE_KEY, fresh);
  } catch {
    /* ignore — caller still gets a usable id from cache */
  }
  cached = fresh;
  return cached;
}

export function __resetSessionIdCacheForTests(): void {
  cached = null;
}
